import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const userBoardVelocityRoute: InvariantJiraRoute = {
	name: 'software-reports-velocity-user-board',
	path: '/jira/people/:accountId/boards/:boardId/reports/velocity',
};
